import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { CatalogDto, UnknownFunction } from '@partnerka-front/types';
import {
  CatalogConditions,
  CatalogCoupon,
  CatalogDescription,
  CatalogInfo,
  CatalogLandings,
  CatalogMaterials,
  CatalogOffers,
  CatalogPreview,
  CatalogPromo,
  CatalogRules,
  CatalogTrafficSources,
} from '@partnerka-front/components';

const CatalogWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;

  ${down('md')} {
    flex-direction: column;
    gap: 10px;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 300px;
  min-width: 300px;

  ${down('md')} {
    width: 100%;
    max-width: 100%;
  }
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

interface CatalogProps {
  catalog: CatalogDto;
  // TODO Переписать через шину событий
  updateCatalog: UnknownFunction;
}

export function Catalog({ catalog, updateCatalog }: CatalogProps) {
  return (
    <CatalogWrapper>
      <Left>
        <CatalogPreview catalog={catalog} updateCatalog={updateCatalog} />
        <CatalogConditions catalog={catalog} />
        <CatalogInfo catalog={catalog} />
      </Left>

      <Right>
        <CatalogDescription catalog={catalog} />

        {catalog.is_confirmed && catalog.landings && catalog.landings.length > 0 && (
          <CatalogLandings
            idCatalog={catalog.id}
            landings={catalog.landings}
            domains={catalog.list_domains}
            updateCatalog={updateCatalog}
          />
        )}

        {catalog.is_confirmed && catalog.is_promocode_allowed && (
          <CatalogPromo
            idCatalog={catalog.id}
            percentDiscounts={catalog.max_promo_code_percent}
            promo_codes={catalog.promo}
          />
        )}

        {catalog.is_confirmed && catalog.is_coupon_allowed && (
          <CatalogCoupon catalogId={catalog.id} coupons={catalog.coupons} />
        )}

        {catalog.offers.length > 0 && (
          <CatalogOffers hold={catalog.hold_duration} offers={catalog.offers} />
        )}

        {catalog.text_rule.length > 0 && (
          <CatalogRules id={catalog.catalog_id} rules={catalog.text_rule} />
        )}

        <CatalogTrafficSources rules={catalog.rules} />

        {catalog.promo_materials.length > 0 && (
          <CatalogMaterials materials={catalog.promo_materials} />
        )}
      </Right>
    </CatalogWrapper>
  );
}
